export default __webpack_public_path__ + "static/media/css.c94bf1da.PNG";